import React, { useState } from "react";
import { firestore } from '../Firebase';
import { Link, Route, BrowserRouter, Switch } from 'react-router-dom';
import AppBar from '../components/AppBar.js';
import SignupPage from '../pages/SignupPage.js';
import Refresh from '../pages/Refresh.js';
import ForgotPassword from '../pages/ForgotPassword.js';

function SignIn(props) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const guest_access = async (e) => {
        e.preventDefault();
        const matches = await firestore.collection("accounts").where("username", '==', "Guest")
            .where("password", "==", "Guest").get()
        matches.docs.forEach(item => {
            props.setUserData(item.data())
            props.student()
        })
    }
    const authenticate = async (e) => {
        e.preventDefault();
        const matches = await firestore.collection('accounts').where('username', '==', username)
            .where('password', '==', password).get()
        if (matches.empty) {
            alert("incorrect password or username")
        }


        else {
            matches.docs.forEach(item => {
                props.setUserData(item.data())
                if (item.data().role === "teacher") {
                    props.teacher()
                }
                else if (item.data().role === "student") {
                    props.student()
                }
                else if (item.data().role === "admin") {
                    props.admin()
                }
            })
        }

    }

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/'>
                    <AppBar />
                    <div className='signupFormDiv' style={{ marginTop: 10 }}>
                        <p class='titleText' style={{ marginBottom: 40, fontSize: 50, textAlign: "center" }}>Welcome, Please Log In</p>
                        <form className="signupForm" onSubmit={authenticate}>
                            <input value={username} onChange={(e) => setUsername(e.target.value)} className="signupFormTextField" placeholder="Username"></input>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="signupFormTextField" placeholder="Password"></input>
                            <div className='submitArea'><button type='submit' className='signupFormSubmitButton'>Sign In</button></div><br />
                            <div className='submitArea'><Link to='/Signup' style={{ textDecoration: 'none' }} className='signupFormSubmitButton'>Register</Link></div>
                            <div className='submitArea'><Link to='/ForgotPassword' style={{ marginTop: 18, textDecoration: 'none', backgroundColor: '#312929' }} className='signupFormSubmitButton'>Forgot Password?</Link></div>
                            <div className='submitArea' ><button type='submit' style={{marginTop: 18}} className='signupFormSubmitButton' onClick={guest_access}>Play as guest</button></div>
                        </form>
                    </div>
                </Route>
                <Route exact path='/Signup' component={SignupPage} />
                <Route path='/ForgotPassword' component={ForgotPassword} />
                <Route exact path='/Home' component={Refresh} />
                <Route path='/Level Select' component={Refresh} />

                <Route path='/level1' component={Refresh} />
                <Route path='/level2' component={Refresh} />
                <Route path='/level3' component={Refresh} />
                <Route path='/level4' component={Refresh} />
                <Route path='/level5' component={Refresh} />
                <Route path='/level6' component={Refresh} />

                <Route path='/levelsmt1' component={Refresh} />
                <Route path='/levelsmt2' component={Refresh} />
                <Route path='/levelsmt3' component={Refresh} />
                <Route path='/levelsmt4' component={Refresh} />
                <Route path='/levelsmt5' component={Refresh} />
                <Route path='/levelsmt6' component={Refresh} />
                <Route path='/levelsmt7' component={Refresh} />
                <Route path='/levelsmt8' component={Refresh} />
                <Route path='/levelsmt9' component={Refresh} />

                <Route path='/levelpnc1' component={Refresh} />
                <Route path='/levelpnc2' component={Refresh} />
                <Route path='/levelpnc3' component={Refresh} />
                <Route path='/levelpnc4' component={Refresh} />
                <Route path='/levelpnc5' component={Refresh} />
                <Route path='/levelpnc6' component={Refresh} />
                <Route path='/levelpnc7' component={Refresh} />
                <Route path='/levelpnc8' component={Refresh} />
                <Route path='/levelpnc9' component={Refresh} />

                <Route path='/levelkrb1' component={Refresh} />
                <Route path='/levelkrb2' component={Refresh} />
                <Route path='/levelkrb3' component={Refresh} />
                <Route path='/levelkrb4' component={Refresh} />
                <Route path='/levelkrb5' component={Refresh} />
                <Route path='/levelkrb6' component={Refresh} />
                <Route path='/levelkrb7' component={Refresh} />
                <Route path='/levelkrb8' component={Refresh} />
                <Route path='/levelkrb9' component={Refresh} />

                <Route path='/leveljfg1' component={Refresh} />
                <Route path='/leveljfg2' component={Refresh} />
                <Route path='/leveljfg3' component={Refresh} />
                <Route path='/leveljfg4' component={Refresh} />
                <Route path='/leveljfg5' component={Refresh} />
                <Route path='/leveljfg6' component={Refresh} />
                <Route path='/leveljfg7' component={Refresh} />
                <Route path='/leveljfg8' component={Refresh} />
                <Route path='/leveljfg9' component={Refresh} />

                <Route path='/levelhdw1' component={Refresh} />
                <Route path='/levelhdw2' component={Refresh} />
                <Route path='/levelhdw3' component={Refresh} />
                <Route path='/levelhdw4' component={Refresh} />
                <Route path='/levelhdw5' component={Refresh} />
                <Route path='/levelhdw6' component={Refresh} />
                <Route path='/levelhdw7' component={Refresh} />
                <Route path='/levelhdw8' component={Refresh} />
                <Route path='/levelhdw9' component={Refresh} />

                <Route path='/levelvly1' component={Refresh} />
                <Route path='/levelvly2' component={Refresh} />
                <Route path='/levelvly3' component={Refresh} />
                <Route path='/levelvly4' component={Refresh} />
                <Route path='/levelvly5' component={Refresh} />
                <Route path='/levelvly6' component={Refresh} />
                <Route path='/levelvly7' component={Refresh} />
                <Route path='/levelvly8' component={Refresh} />
                <Route path='/levelvly9' component={Refresh} />

                <Route path='/Verification' component={Refresh} />
            </Switch>
        </BrowserRouter >
    )
}
export default SignIn
